import React, { useRef, useEffect, useState } from 'react';
import { Input } from '@arco-design/web-react';

/**
 * 自适应宽度的输入框
 * @param {string} value 输入框内容
 * @param {function} onChange 输入变化回调
 * @param {string} placeholder 占位符
 * @param {object} rest 其他 Input 属性
 */
export default function AutoWidthInput({ value, onChange, placeholder, addBefore, ...rest }) {
  const spanRef = useRef(null);
  const [inputWidth, setInputWidth] = useState(120); // 初始宽度
  
  // 组合 addBefore 和 value
  const displayText = `${addBefore ? (typeof addBefore === 'string' ? addBefore : '') : ''}${value || placeholder || ''}`;

  useEffect(() => {
    if (spanRef.current) {
      setInputWidth(spanRef.current.offsetWidth + 60); // 适当加点padding
    }
  }, [value, placeholder, addBefore]);

  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <Input
        {...rest}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        addBefore={addBefore} // 这里必须加上
        style={{ width: inputWidth, minWidth: 142, maxWidth: 600, ...rest.style }}
      />
      {/* 隐藏的 span 用于测量宽度 */}
      <span
        ref={spanRef}
        style={{
          position: 'absolute',
          visibility: 'hidden',
          height: 0,
          overflow: 'scroll',
          whiteSpace: 'pre',
          fontSize: 14, // 保持和Input一致
          fontFamily: 'inherit',
          padding: 0,
          margin: 0,
        }}
      >
        {displayText}
      </span>
    </div>
  );
}